<template>
  <v-row dense>
    <v-col cols="12">
      <v-card
        tile
        color="primary"
        class="elevation-0 mb-2"
      >
        <v-card-title
          class="font-weight-medium grey--text pt-1 pb-2"
        >
          Invitados
        </v-card-title>
        <v-card-subtitle class="pb-2">
          Lista de invitaciones a la propiedad
        </v-card-subtitle>
      </v-card>
      <v-card
        tile
        color="grey lighten-3"
        class="elevation-0"
      >
        <v-container fluid>
          <v-row dense>
            <v-col cols="3" sm="2">
              <v-select
                v-model="form.area"
                :items="areas"
                label="Area"
                item-text="name"
                item-value="id"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="3" sm="2">
              <v-select
                v-model="form.status"
                :items="invitationStatus"
                label="Estados"
                item-text="name"
                item-value="id"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="3" sm="2">
              <date-component
                v-model="form.date_entry"
                label="Fecha"
              ></date-component>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="3" sm="4">
              <v-text-field
              v-model="form.search"
              label="Buscar"
              hide-details
              dense
              outlined
              append-icon="mdi-magnify"
            >
              <template v-if="form.search" v-slot:append>
                <v-icon
                  @click.prevent="crearFilters"
                  link
                >
                  mdi-close
                </v-icon>
              </template>
            </v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card>

      <v-card class="elevation-0 mt-3" tile>
        <v-data-table
          :headers="headers"
          :items="invitations"
          class="elevation-0"
          :options.sync="options"
          :server-items-length="totalIntivations"
          :loading="loading"
          disable-sort
        >
          <template v-slot:item.invitated.name="{ item }">
            {{ item.invitated.name }}
            <span v-if="item.total_companions">({{ item.total_companions }})</span>
            <br>
            <v-chip
              label small dark
              :color="getTypeColor(item.type_invitation)"
              class="mb-1"
            >
              {{ item.type_invitation }}
            </v-chip>
          </template>
          <template v-slot:item.property="{ item }">
            <template v-if="item.property">
              <span
                class="text-capitalize"
              >
                {{ item.property.toLowerCase() }}
              </span>
            </template>
            <template v-else>
              <span>
              {{ item.venue.name }}
              </span>
              <br>
              <v-chip
                v-if="item.event.name"
                label
                small
                class="mb-1"
              >
                {{ item.event.name }}
              </v-chip>
            </template>
          </template>
          <template v-slot:item.area="{ item }">
            <span v-if="item.area" class="text-capitalize">{{ item.area.toLowerCase() }}</span>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip
              small
              label
              :color="getColor(item.status)"
              dark
              class="v-btn--block v-chip-status"
            >
              {{ item.status }}
            </v-chip>
          </template>
          <template v-slot:item.date_entry="{ item }">
            {{ item.date_entry|date }}
          </template>
          <template v-slot:item.date_out="{ item }">
            {{ item.date_out|date }}
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn
              dense
              outlined
              small
              :color="getColor(item.status)"
              block
              @click="dispatchAction(item.status, item.id)"
            >
              {{ getAction(item.status) }}
          </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
    <checkin-component
      v-model="showCheckin"
      :invitationId="invitationId"
    ></checkin-component>
    <checkout-component
      v-model="showCheckout"
      :invitationId="invitationId"
    ></checkout-component>
    <checkout-detail-component
      v-model="showDetailCheckout"
      :invitationId="invitationId"
    ></checkout-detail-component>
  </v-row>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import types from '@/types';
import DateComponent from '@/components/DateComponent';
import CheckinComponent from '@/components/CheckinComponent';
import CheckoutComponent from '@/components/CheckoutComponent';
import CheckoutDetailComponent from '@/components/CheckoutDetailComponent';
import _ from 'lodash';

export default {
  components: {
    DateComponent,
    CheckinComponent,
    CheckoutComponent,
    CheckoutDetailComponent,
  },

  data() {
    return {
      form: {
        area: '',
        status: '',
        date_entry: '',
        search: '',
      },
      options: {},
      headers: [
        { text: 'Invitado / Proveedor', value: 'invitated.name' },
        { text: 'Propiedad', value: 'property' },
        { text: 'Area', value: 'area' },
        { text: 'Estado', value: 'status' },
        { text: 'Fecha llegada', value: 'date_entry' },
        { text: 'Fecha salida', value: 'date_out' },
        {
          text: 'Acciones', value: 'action', sortable: false, align: 'end',
        },
      ],
      loading: true,
      invitationId: null,
      showCheckin: false,
      showCheckout: false,
      showDetailCheckout: false,
      autoUpdate: true,
      interval: null,
    };
  },

  computed: {
    ...mapState(
      `${types.INVITATION}`, [
        'areas',
        'invitationStatus',
        'invitations',
        'totalIntivations',
      ],
    ),
    limit() {
      return this.options.itemsPerPage === -1
        ? this.totalIntivations : this.options.itemsPerPage;
    },
  },

  watch: {
    form: {
      handler() {
        const clearPage = true;
        this.debouncedGetInvitations(this.getOptions(clearPage));
      },
      deep: true,
    },
    options: {
      handler() {
        const clearPage = false;
        this.getInvitations(this.getOptions(clearPage));
      },
      deep: true,
    },
  },

  methods: {
    ...mapMutations({
      [types.SHOW_BUSY]: `${types.APP}/${types.SHOW_BUSY}`,
      [types.HIDE_BUSY]: `${types.APP}/${types.HIDE_BUSY}`,
    }),
    ...mapActions({
      [types.SETUP_BACKOFFICE]: `${types.INVITATION}/${types.SETUP_BACKOFFICE}`,
      [types.GET_INVITATIONS]: `${types.INVITATION}/${types.GET_INVITATIONS}`,
    }),
    getOptions(clearPage) {
      const params = {
        area: this.form.area,
        status: this.form.status,
        date_entry: this.form.date_entry,
        search: this.form.search,
        page: this.options.page,
        limit: this.limit,
      };
      if (clearPage) {
        delete params.page;
      }
      return params;
    },
    getTypeColor(type) {
      const colors = {
        'Family/Friends': 'light-blue darken-3',
        'Friends and Family': 'light-blue darken-3',
        Supplier: 'warning',
      };
      return colors[type];
    },
    getColor(status) {
      const colors = {
        Pending: 'success',
        'In House': 'warning lighten-1',
        'Check Out': 'error lighten-1',
        Cancelled: 'grey',
        'Overdue In House': 'error darken-1',
      };
      return colors[status];
    },
    getAction(status) {
      const actions = {
        Pending: 'Check-in',
        'In House': 'Check-out',
        'Check Out': 'Ver',
        Cancelled: 'Ver',
        'Overdue In House': 'Check-out',
      };
      return actions[status];
    },
    getInvitations(params) {
      this.loading = true;
      this[types.GET_INVITATIONS](params)
        .then(() => {
          this.checkNewInvitations();
        })
        .catch(() => {
        })
        .finally(() => {
          this[types.HIDE_BUSY]();
          this.loading = false;
        });
    },
    dispatchAction(status, invitationId) {
      switch (status) {
        case 'Pending':
          this.invitationId = invitationId;
          this.showCheckin = true;
          break;
        case 'In House':
        case 'Overdue In House':
          this.invitationId = invitationId;
          this.showCheckout = true;
          break;
        case 'Check Out':
          this.invitationId = invitationId;
          this.showDetailCheckout = true;
          break;
        default:
          this.$router.push({ name: 'Todo' });
          break;
      }
    },
    crearFilters() {
      this.form.search = '';
      this.form.date_entry = '';
    },
    checkNewInvitations() {
      // Verificar en el BK si existen nuevas invitations.
      // Mostrarle al usuario que existen nuevas invitaciones
      // Si existen nuevas invitaciones darle la opcion de refrescar la lista.
      if (this.interval) {
        return;
      }
      this.interval = setInterval(() => {
        if (this.autoUpdate) {
          this.getInvitations();
        }
      }, 600000);
    },
  },

  mounted() {
    this[types.SHOW_BUSY]('Cargando...');
    this[types.SETUP_BACKOFFICE]();
    this.getInvitations();
    this.debouncedGetInvitations = _.debounce(this.getInvitations, 1000);
  },

  destroyed() {
    clearInterval(this.interval);
  },
};
</script>

<style>
.v-data-table__wrapper tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, .05);
}
.v-chip-status {
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/Invitations.vue